var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-layout-default-authed-header',{attrs:{"show-contact":false,"show-account":false,"show-logout":false,"factfind":""}}),_c('v-main',[_c('app',{staticClass:"pa-5"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }